import { hide, show, useLoading, useLoadingGlobal } from './loading.js';

export const loading = {
  show,
  hide,
  useLoading,
  useLoadingGlobal,
};
